import { LOAD_ALL_COMPANIES, LOAD_SINGLE_COMPANY } from "./CompanyList.saga";

export const loadAllCompanies = (payload) => ({
  type: LOAD_ALL_COMPANIES.LOADING,
  payload,
});

export const loadSingleCompany = (payload) => ({
  type: LOAD_SINGLE_COMPANY.LOADING,
  payload,
});
